<template>
  <div>
    <highcharts :options="chartOptions" :highcharts="hcInstance" />
  </div>
</template>

<script>
import Highcharts from "highcharts";

export default {
  props: ["data"],
  data: () => ({
    hcInstance: Highcharts,
    chartOptions: {}
  }),
  methods: {
    loadData() {
      this.chartOptions = {
        chart: {
          type: "area",
        },
        title: {
          text: "",
        },
        colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        xAxis: {
          categories: this.data.xAxis
        },
        legend: {
          layout: "vertical",
          align: "left",
          verticalAlign: "top",
          x: 100,
          y: 70,
          floating: true,
          borderWidth: 1,
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || "#FFFFFF",
        },
        plotOptions: {
          column: {
            stacking: 'normal',
          },
          area: {
            fillOpacity: 0.5,
          },
        },
        credits: {
          enabled: false,
        },
        series: this.data.series
      };
    }
  },
  watch: {
    "data": {
      handler(value) {
        if (value)
          this.loadData();
      }
    }
  }
}
</script>